module.exports = "/images/FeaturedBannerMobile.jpg?f7a18678470183c1960b10c500029ce1";